import type { Category } from "@/types";
import { stringifyCsv } from "./csv";

export const MANAGE_CATEGORIES_CSV_COLUMNS = [
  "kind",
  "category_name",
  "category_description",
  "subcategory_name",
  "subcategory_description",
] as const;

/**
 * One row per subcategory; category fields repeat. Categories with no
 * subcategories appear as a single row with empty subcategory columns.
 */
export function buildManageCategoriesCsv(categories: Category[]): string {
  const rows: string[][] = [[...MANAGE_CATEGORIES_CSV_COLUMNS]];
  for (const cat of categories) {
    const kind = cat.kind ?? "expense";
    const catName = cat.name ?? "";
    const catDesc = cat.description ?? "";
    const subs = [...(cat.subcategories ?? [])].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    if (subs.length === 0) {
      rows.push([kind, catName, catDesc, "", ""]);
    } else {
      for (const s of subs) {
        rows.push([kind, catName, catDesc, s.name ?? "", s.description ?? ""]);
      }
    }
  }
  return stringifyCsv(rows);
}

export function manageCategoriesCsvHeadersMatch(headerRow: string[]): boolean {
  if (headerRow.length !== MANAGE_CATEGORIES_CSV_COLUMNS.length) return false;
  return MANAGE_CATEGORIES_CSV_COLUMNS.every((h, i) => headerRow[i] === h);
}
